import React, { useState, useEffect } from 'react';
import PopUp from '../../../../../commonModules/interface/PopUp';
import { TableLayout } from '../../containers/Layout';
import { Box, Button, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import FormReappro from '../../reapproIntern/FormReappro';
import { SearchRounded, SyncProblemRounded } from '@material-ui/icons';
import { amber, green } from '@material-ui/core/colors';
import Form from '../../resas/Form';
import DemandTransferReaFrom from './DemandTransferReaFrom';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { makeResa } from '../../../../../../../../jsx/actions/resaAction';
import { singleTransferGet } from '../../../../../../../../jsx/actions/transferAction';
import { createSale } from '../../../../../../../../jsx/actions/saleAction';
import ConfirmValidateTransfer from '../../../../../commonModules/interface/ConfirmValidateTransfer';
import SendToTransfer from '../../../../../commonModules/interface/SendToTransfer';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';

const gBrd = "1px solid lightgrey";

const DispatchResaDemandTransfer = (props) => {
    const STATE = useSelector((state) => state.inventory.requestState); 
    const SHOPS = useSelector((state) => state.inventory.shops);
    const PRODUCTS = useSelector((state) => state.inventory.products);
    const AVAILABLE = useSelector((state) => state.inventory.stocks.AVAILABLE);
    const dispatch = useDispatch();
    const fetchTransfers = useFetchTransfers("reservation_demande");

    // const [RESA, setReservedStock] = useState([]);
    const [productListInfos,setProductListInfos] = useState(<div></div>)
    const [disabledSubmit,setDisabledSubmit] = useState(false)
    const [state, setState] = useState({
        dialogStock: false,
        resaProds: null,
        openValidateResa: false,
        openSendTo: false,
        openRea: false,
        rea: {},
        over: false,
        resaItems: [],
    });

    useEffect(() => {
        const productInfodiv = createProductList();
        setProductListInfos(productInfodiv);
    }, [state.resaProds,props.resa.transfer_validate])

    useEffect(() => {
        const fetchData = async () => {
            await fetchStocks();
        };
        fetchData();
    }, [])

    const fetchStocks = () => {
        const { resa } = props;
        const resaProds = {};

        
        resa.products.forEach((prod) => {
            const dispo = !isEmpty(AVAILABLE) && AVAILABLE[`${resa.shop_id}|${prod.product_id}|AVAILABLE`] ? AVAILABLE[`${resa.shop_id}|${prod.product_id}|AVAILABLE`].quantity : 0;
            const availableOtherShops = Object.values(AVAILABLE).filter((stock) => !SHOPS[stock.shop_id].shop_disabled).filter((stock) => stock.product_id === prod.product_id && stock.quantity > 0 && resa.shop_id !== stock.shop_id);
            let totalOther = 0;
    
            if (!isEmpty(availableOtherShops)) {
                availableOtherShops.forEach((stock) => (totalOther += stock.quantity));
            }
            resaProds[prod.product_id] = {
                product_id: prod.product_id,
                quantity: prod.quantity,
                qtyDispoShop: dispo,
                qtyDispoOther: totalOther,
                reserved:0,
                waiting:0,
                qtyMissing:prod.quantity,
                qtyToRea:prod.quantity,
            };
        })

        let totalResa = 0
        let totalWaiting = 0
        resa.resa_products && resa.resa_products.forEach((prod) => {
            let reserved = prod.status == "RESERVATION" || "AVAILABLE" ? prod.quantity : 0 // AVAILABLE == reservé puis validé
            let waiting = prod.status == "WAITING_DELIVERY" ? prod.quantity : 0
            totalResa += reserved
            totalWaiting += waiting
            
            if (resaProds[prod.product_id]){
                resaProds[prod.product_id].reserved += reserved
                resaProds[prod.product_id].waiting += waiting
                resaProds[prod.product_id].qtyMissing -= (reserved + waiting)
                resaProds[prod.product_id].qtyToRea -= (reserved + waiting)
            } else {
                resaProds[prod.product_id] = {
                    product_id: prod.product_id,
                    reserved,
                    waiting,
                    addedByAdmin: true
                };
            }
        })
        let over = false
        if (totalResa > 0 && totalWaiting == 0) {
            over = true
        }
        setState((prevState) => ({
            ...prevState,
            resaProds,
            over,
        }));
    }
    const createProductList = () => {
        const { resaProds } = state;

        console.log('====================================');
        console.log({resaProds});
        console.log('====================================');
        try{
            return Object.values(resaProds).map( (prod) => {
                const qtyDispo = prod.qtyDispoShop;
                const total = prod.qtyDispoOther + qtyDispo;
                let color = "";
                let status = "";
    
                if (prod.reserved >= prod.quantity) {
                    color = "green";
                    status = "ok";
                } else if (prod.reserved > 0) {
                    color = amber[500];
                    status = "rea";
                }
    
                return (
                    <TableRow key={prod.product_id} style={{ fontStyle: (prod.addedByAdmin && "italic") , backgroundColor: (prod.addedByAdmin && "lightgrey")}} >
                        <TableCell style={{ borderLeft: gBrd, borderRight: gBrd }}>{PRODUCTS[prod.product_id].name}</TableCell>
                        <TableCell style={{ textAlign: "center" }}>{prod.quantity || "--"}</TableCell>
                        {(props.resa.resa_status ==="ready" || props.resa.resa_status ==="dispatch" ) ?
                            <TableCell style={{ backgroundColor: green[100], textAlign: "center", borderRight: gBrd }}>
                                <Typography variant="h6" style={{ color: "green" }}>
                                    <b>{prod.reserved}</b>
                                </Typography>
                            </TableCell>                        
                        :
                            <>
                                <TableCell style={{ backgroundColor: amber[100], textAlign: "center" }}>
                                    {prod.waiting >= prod.quantity ? (
                                        <Typography variant="h6" style={{ color: "orange" }}>
                                            <b>{prod.waiting}</b>
                                        </Typography>
                                    ) : (
                                        prod.waiting
                                    )}
                                </TableCell>
                                <TableCell style={{ backgroundColor: green[100], textAlign: "center", borderRight: gBrd }}>
                                    {status === "ok" ? (
                                        <Typography variant="h6" style={{ color: color }}>
                                            <b>{prod.reserved}</b>
                                        </Typography>
                                    ) : (
                                        prod.reserved
                                    )}
                                </TableCell>
                                <TableCell style={{ borderRight: gBrd }}>
                                    {prod.quantity > prod.reserved + prod.waiting && (
                                        <>
                                            {total > 0 ? (
                                            <Button
                                                startIcon={<SearchRounded />}
                                                color="primary"
                                                variant="contained"
                                                style={{ width: "100%" }}
                                                onClick={() => setState({ ...state, dialogStock: true })}
                                            >
                                                {total}
                                            </Button>
                                            ) : (
                                                <Button
                                                    startIcon={<SyncProblemRounded />}
                                                    color="primary"
                                                    disabled
                                                    variant="contained"
                                                    style={{ width: "100%" }}
                                                    onClick={() => setState({ ...state,  dialogExchange: true })}
                                                >
                                                    Indisponible
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </TableCell>
                            </>
                        }
                    </TableRow>
                );
            });
        }catch(err){
            console.log("[ERROR]",err.message)
            return <div></div>
        }

    };

    const formatReaSendTo = () => {
        const { resaProds} = state;
        const { resa } = props;
        console.log('====================================');
        console.log({resaProds, resa});
        console.log('====================================');
        let rea = Object.assign({}, resa)

        let newProdList = []
        Object.values(resaProds).forEach(prod => {
            if (prod.reserved > 0 ) {
                prod.quantity = prod.reserved
                newProdList.push(prod)
            }
        })
        rea.products = newProdList
        handleOpenSendToRea(resa.shop_id, rea)
    }
    

    const handleOpenRea = (src, rea) => {

        if (src !== rea.shop_id) {
            rea.shop_dest = rea.shop_id;
            rea.shop_id = src;
            rea.resa_demand_id = props.resa.id
            setState({ ...state, rea, openRea: true });
        } else {
            setState({ ...state, rea, openResa: true });
        }
    };
    const handleOpenSendToRea = (src, rea) => {
            rea.shop_id = rea.shop_id;
            rea.resa_demand_id = props.resa.id
            setState({ ...state, rea, openRea: true });
    };
    const handleValidateResa = () => {
        setState({ ...state, openValidateResa: true });
    };
    const handleSendTo = () => {
        setState({ ...state, openSendTo: true });
    };
    const handleSubmit =  () => {
        setDisabledSubmit(true)
        props.validateResa()
        setState({ ...state, openValidateResa: false });
        setDisabledSubmit(false)
        fetchTransfers();
    };

    const createNewResa = async (resa) => {
        await dispatch(makeResa(resa));
    
        await props.fetchTransferData()
        await fetchStocks();
        //TO DO 
    };

    const createNewReappro = async (resa) => {
        await dispatch(createSale(resa));
        console.log("[INFO],createNewReappro")
        await props.fetchTransferData()
        console.log("[INFO],createNewReappro,fetchDATA")
        await fetchStocks();
        console.log("[INFO],createNewReappro,fetchStocks")
    };
    
    const closeSubmit = async () =>{
        console.log("[INFO], closeSubmit, Validation")
        setDisabledSubmit(false)
        setState({ ...state, rea: {}, openResa: false, dialogStock: false ,openSendTo:false})
        await props.fetchTransferData()
        await fetchStocks();
        await fetchTransfers();
    }

    return (
        <>
            {state.dialogStock && (
                <PopUp
                    close={() => setState({ ...state, dialogStock: false  })}
                    title={"Produits Manquants"}
                    appbar
                    primaryAppbar
                >
                    <DemandTransferReaFrom
                        // handleCloseStock={() => setState({ dialogStock: false })}
                        // {...props}
                        resa={props.resa}
                        resaProds={state.resaProds}
                        handleClose={() => setState({ ...state, dialogStock: false })}
                        AVAILABLE={AVAILABLE}
                        SHOPS={SHOPS}
                        PRODUCTS={PRODUCTS}
                        handleOpenRea={handleOpenRea}
                    />
                </PopUp>
            )}

            {state.openRea && (
                <PopUp
                    title={`Réappro —`}
                    close={() => setState({ ...state, rea: {}, openRea: false })}
                    appbar
                    maxWidth="md"
                >
                    <FormReappro
                        // {...props}
                        createSale={createNewReappro}
                        STATE={STATE}
                        SHOPS={SHOPS}
                        AVAILABLE={AVAILABLE}
                        PRODUCTS={PRODUCTS}
                        handleClose={() => setState({ ...state, rea: {}, openRea: false })}
                        closeSubmit={closeSubmit}
                        oldRea={state.rea}
                        fromResa={!props.resa.transfer_validate}
                        sendTo={props.resa.transfer_validate}
                    />
                </PopUp>
            )}

            {state.openResa && (
                <PopUp
                    title={`Reserver les produits`}
                    close={() => setState({ ...state, rea: {}, openResa: false })}
                    appbar
                    maxWidth="md"
                >
                    <Form
                        // {...props}
                        createNewResa={createNewResa}sd
                        // handleSubmit={handleSubmit}
                        STATE={STATE}
                        SHOPS={SHOPS}
                        PRODUCTS={PRODUCTS}
                        AVAILABLE={AVAILABLE}
                        handleClose={() => setState({ ...state, rea: {}, openResa: false })}
                        closeSubmit={closeSubmit}
                        oldRea={state.rea}
                    />
                </PopUp>
            )}
            {state.openValidateResa && 
                <ConfirmValidateTransfer
                    title={`la reservation`}
                    close={() => setState({ ...state, openValidateResa: false })}
                    handleSubmit={handleSubmit}
                />
            }
            {state.openSendTo && 
                <SendToTransfer
                    close={() => setState({ ...state, openSendTo: false })}
                    reappro={formatReaSendTo}
                      
                />
            }


            {state.over && props.resa.resa_status != "dispatch" &&
                <Box p={1}>
                    {props.resa.transfer_validate ?
                        <Button color="primary" variant="contained" onClick={handleSendTo} disabled={disabledSubmit}>
                            {/* send to install / reappro / other */}
                            {disabledSubmit ? 'Traitement en cours...' :  "Envoyer vers"}
                        </Button>
                    :
                        <Button color="primary" variant="contained" onClick={handleValidateResa} disabled={disabledSubmit}>
                            {disabledSubmit ? 'Traitement en cours...' :  "Valider la reservation"}
                        </Button>
                    }
                </Box>
            }
            
            <TableLayout>
                <TableHead> 
                    <TableRow>
                        <TableCell style={{ textAlign: "center", border: gBrd }}>Produit</TableCell>
                        <TableCell style={{ textAlign: "center", borderTop: gBrd, borderBottom: gBrd }}>Quantité(s) Demandée(s)</TableCell>
                        {(props.resa.resa_status ==="ready" || props.resa.resa_status ==="dispatch" )?
                                <TableCell style={{ textAlign: "center", borderTop: gBrd, borderBottom: gBrd, backgroundColor: green[100] }}>Quantité finale</TableCell>
                        :
                            <>
                                <TableCell style={{ textAlign: "center", borderTop: gBrd, borderBottom: gBrd, backgroundColor: amber[100] }}>En attente</TableCell>
                                <TableCell style={{ textAlign: "center", borderTop: gBrd, borderBottom: gBrd, borderRight: gBrd, backgroundColor: green[100] }}>Reservé</TableCell>
                                <TableCell style={{ textAlign: "center", borderTop: gBrd, borderBottom: gBrd, borderRight: gBrd }}>En Stock</TableCell>
                            </>
                        }
                    </TableRow>
                </TableHead>
                <TableBody>{state.resaProds && productListInfos}</TableBody>
            </TableLayout>
        </>
    );
};

export default DispatchResaDemandTransfer;


{/* TODO: 
    List all articles  
        - 4 colonnes
            +—— PRODUCT ——+—— Qty Ask ——+—— Qty Dispo ——+—— Qty to reappro ——+
            |             |             |               |                    | 
*/}